import { Heading } from "@digdir/designsystemet-react";
import type { SnapWidgetBlockProps } from './types';
import { useEffect } from 'react';

export type { SnapWidgetBlockProps };

export function SnapWidgetBlock({ linkUrl, blockTitle }: SnapWidgetBlockProps) {
  useEffect(() => {
    if (!document.querySelector('script[src="https://snapwidget.com/js/snapwidget.js"]')) {
      const script = document.createElement('script');
      script.src = 'https://snapwidget.com/js/snapwidget.js';
      script.async = true;
      document.head.appendChild(script);
    }
  }, []);

  return (
    <section>
      {blockTitle && (
        <Heading>
          {blockTitle}
        </Heading>
      )}
      <div>
        <iframe 
          src={linkUrl} 
          className="snapwidget-widget w-full" 
          allowTransparency={true} 
        />
      </div>
    </section>
  );
}
